import React, { FC } from 'react'
import { styled } from '@moonpig/launchpad-utils'
import { Box } from '@moonpig/launchpad-components'
import { system as s } from '@moonpig/launchpad-system'

const StyledResultsCount = styled(Box)`
  ${s({
    color: 'colorBlack60',
    typography: 'typeBodyText',
    display: 'inline',
  })}
`

export const ResultsCountHeader: FC<{
  count?: number
}> = ({ count }) => {
  const resultCountNumber = (value: number) => {
    if (value > 500) {
      return `(500+)`
    }
    return `(${value})`
  }

  return count && count > 0 ? (
    <StyledResultsCount data-testid="web-find-total-product-count">
      {resultCountNumber(count)}
    </StyledResultsCount>
  ) : (
    <StyledResultsCount data-testid="web-find-total-product-count" />
  )
}
